import { API_URL } from "../../../../../../constants";
import * as httpNetworking from "../../../../../../httpNetworking";

const VERSION = 0;

export async function getDbInfoForMultiTenantApp(data: {
    deploymentId: string;
    appId: string;
}): Promise<{
    count: number;
}> {
    const { deploymentId, appId } = data;

    const options: httpNetworking.GETRequestConfig = {
        params: {
            deploymentId
        }
    };

    const url = `${API_URL}/saas/multi-tenancy/connection-uri-domain/${appId}/db`;

    const result = await httpNetworking.simpleGETRequest(url, options, VERSION);
    return result.data;
}
